export enum AWS_LAMBDAS {
  linkUser = 'dev_linkUsernameToIdentityId',
  payments = 'dev_payments',
  dashboard = 'dev_getDashboardMetrics',
  exploreStoriesWithLink = 'dev_exploreStoriesWithLink',
  familyAction = 'dev_familyActions',
  reviewFinalMessage = 'dev_reviewFinalMessage',
  storageUsage = 'dev_getStorageUsage',
  manageFamilyPlan = 'dev_manageFamilyPlan',
  syncProfile = 'dev_syncCognitoContactInfo',
  getProfileThumbnail = 'dev_getProfileThumbnail',
  getAffiliateProfile = 'dev_getAffiliateProfile',
}

export enum AWS_LAMBDAS_OPERATIONS {
  dontRenewSubscription = 'dontRenewSubscription',
  createPaymentIntent = 'createPaymentIntent',
  getPayments = 'getPayments',
  getProductList = 'getProductList',
  joinFamilyPlan = 'joinFamilyPlan',
  selectFreePlan = 'selectFreePlan',
  getAccountHolderName = 'getAccountHolderName',
  registerEvent = 'registerEvent',
  getStoryList = 'getStoryList',
  getFinalMessage = 'getMessage',
  registerFinalMessagePlayed = 'messagePlayed',
  rejectFinalMessage = 'rejectMessage',
  getFamilyMemberSlotStatus = 'getFamilyMemberSlotStatus',
  inviteFamilyMember = 'inviteFamilyMember',
  beginEmailDomainChallenge = 'beginEmailDomainChallenge',
  acceptCorporatePlan = 'acceptCorporatePlan',
}

export enum AWS_LAMBDA_ERRORS {
  noData = 'No data returned',
  unknownFormat = 'Some problems with the data received: unknown format',
}
